<template>
  <div class="_component-floating-toolbar" v-if="init">
    <LoginModal v-if="showLoginModal" :initState="loginModalType" :modal="true" @close="showLoginModal = false" />
    <SideHelperMobile />
    <!-- <MiniProgramTalenhunt v-if="isShowTalenhunt" /> -->
    <UserDropdown v-if="isShowUserDropdown" @select="handleSelect">
      <template v-slot:trigger>
        <div class="user-info">
          <SvgIcon name="icon-user" color="#fff" />
        </div>
      </template>
    </UserDropdown>
  </div>
</template>

<script>
import SvgIcon from '../SvgIcon';
// import MiniProgramTalenhunt from '../MiniProgram/Talenhunt';
import SideHelperMobile from '../SideHelper/Mobile';
import LoginModal from '../login/Modal';
import LOGIN_STATE from '../login/loginState';
import LoginHelper from 'utils/login';
import UserDropdown from '../UserDropdown';
import Login from '@/utils/login';

export default {
  name: 'FloatingToolbar',
  components: {
    // MiniProgramTalenhunt,
    SideHelperMobile,
    SvgIcon,
    LoginModal,
    UserDropdown
  },
  data: () => ({
    init: false,
    showLoginModal: false,
    loginModalType: LOGIN_STATE.LOGIN,
    statusData: {},
    userInfo: {}
  }),
  computed: {
    // isInApplyPage() {
    //   return ['/student/apply', '/hsylc/apply', '/volunteer/application'].includes(window.location.pathname);
    // },
    // isShowTalenhunt() {
    //   return this.init && this.$isMiniProgram && !this.isInApplyPage;
    // },
    isShowUserDropdownPage() {
      return ['/student/apply', '/hsylc/apply', '/student/admission', '/volunteer/application', '/dashboard'].includes(this.$route.path);
    },
    isShowUserDropdown() {
      return this.$isMiniProgram && this.isShowUserDropdownPage && this.userInfo.user_id;
    }
  },
  async created() {
    const status = await Login.getStatusData();
    this.userInfo = status || {};
    this.$login.getCommonLoginData();
    if (LoginHelper.isLogin()) {
      this.statusData = await LoginHelper.getStatusData();
    }
  },
  async mounted() {
    this.init = true;
  },
  methods: {
    /**
     * @function handleSelect 处理下拉菜单选择事件
     * @param {String} key 选择的菜单项key
     */
    handleSelect(key) {
      if (key === 'set-password' && !this.$isMiniProgram) {
        const track = new this.$track();
        track.track('hsylc_password_edit', { beacon: true });
        this.loginModalType = LOGIN_STATE.FIND_PASSWORD;
        this.showLoginModal = true;
      }
    }
  }
};
</script>

<style lang="less" scoped src="./index.less"></style>
